"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _intl = require("@kyruus/intl");
var _propTypes = require("prop-types");
var _banner = _interopRequireDefault(require("@kyruus/banner"));
var _Warning = _interopRequireDefault(require("@kyruus/react-ikons/Warning"));
var _styles = require("./styles");
var _PhoneNumberLink = _interopRequireDefault(require("../../../components/PhoneNumberLink/PhoneNumberLink"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
const ErrorPageSharedContent = _ref => {
  let {
    errorHeadingText,
    bannerText,
    phone
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ErrorPageContentWrapper, null, /*#__PURE__*/_react.default.createElement(_styles.ErrorHeading, null, /*#__PURE__*/_react.default.createElement(_Warning.default, {
    size: "36px"
  }), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default[errorHeadingText])), /*#__PURE__*/_react.default.createElement(_banner.default, {
    type: "info",
    icon: "i",
    "data-testid": "CancelDisabledErrorBanner"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default[bannerText], {
    values: phone ? {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone
      })
    } : undefined
  }))));
};
ErrorPageSharedContent.propTypes = {
  errorHeadingText: _propTypes.string.isRequired,
  bannerText: _propTypes.string.isRequired,
  phone: _propTypes.string
};
var _default = exports.default = ErrorPageSharedContent;
ErrorPageSharedContent.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorPageSharedContent",
  "props": {
    "errorHeadingText": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "bannerText": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "phone": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};